import React from "react";
import { Container, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  layout: {
    display: "flex",
    minHeight: "calc(100vh - 292px)",
    marginBottom: "55px",
    flexDirection: "column",
  },
});

export const Layout = (props) => {
  const styles = useStyles();
  return (
    <Container className={styles.layout} maxWidth="sm">
      {props.children}
    </Container>
  );
};
